export default __webpack_public_path__ + "static/media/legal-fr.296ea137.md";